<template>
  <div>
    <div class="info-item">
      <span><span style="color:red">*</span>单位名称：<Input
          v-model="info.purchase"
          placeholder="采购人名称"
          :readonly="!editSta"
          style="width:250px"
        /></span>
    </div>
    <div class="info-item">
      <span><span style="color:red">*</span>单位属性：
        <Select
          v-model="info.purchaseSite"
          style="width:160px;display:inline-block;"
          :disabled="!editSta"
          @on-change="siteChange"
        >
          <Option
            v-for="item in purchaseSiteArr"
            :value="item.itemName"
            :key="item.key"
          >{{ item.itemName }}</Option>
        </Select>
      </span>
    </div>
    <div class="info-item">
      <span><span style="color:red">*</span>所属行业：
        <Select
          v-model="info.sysIndustry"
          style="width:190px;display:inline-block;"
          :disabled="!editSta"
        >
          <Option
            v-for="item in systemArr"
            :value="item.itemName"
            :key="item.key"
          >{{ item.itemName }}</Option>
        </Select>
      </span>
    </div>
    <div class="info-item" v-if="info.purchaseSite==='军工企业'">
      <span><span style="color:red">*</span>采购人名称：
        <Select
          v-model="info.attachedUnit"
          style="width:190px;display:inline-block"
          :disabled="!editSta"
        >
          <Option
            v-for="item in cgrList"
            :value="item.itemName"
            :key="item.key"
          >{{ item.itemName }}</Option>
        </Select>
      </span>
    </div>
    <div class="info-item">
      <span><span style="color:red">*</span>客户人员：
        <Select v-model="info.accountAssistant" style="width:250px;display:inline-block;" :disabled="!editSta" clearable>
          <Option v-for="item in amArr" :value="item.am" :label="item.am" :key="item.userId" :disabled="!(item.clientQuota==null||item.clientQuota>item.count)">
            <span>{{ item.am }}</span>
            <span style="float:right;color:#ccc">客户数量：{{item.count}} / {{item.clientQuota || '无'}}</span>
          </Option>
        </Select></span>
    </div>
    <div class="info-item">
      <span><span style="color:red">*</span>归属团队：
        <Select
          v-model="info.filiale"
          style="width:160px;display:inline-block"
          :disabled="!editSta"
        >
          <Option
            v-for="item in companyArea"
            :value="item.name"
            :key="item.key"
          >{{ item.name }}</Option>
        </Select>
      </span>
    </div>
    <div class="info-item" v-if="info.purchaseSite!=='部队'&&info.purchaseSite!=='军工企业'">
      <span>
        <span style="color:red">*</span>
        所属行政级别(原资金来源)：
        <Select
          v-model="info.fundingSource"
          style="width:90px;display:inline-block;"
          :disabled="!editSta"
        >
          <Option
            v-for="item in sourceArr"
            :value="item.itemName"
            :key="item.key"
          >{{ item.itemName }}</Option>
        </Select>
      </span>
    </div>
    <div v-if="info.purchaseSite==='部队'">
      <div class="info-item">
        <span>
          <span style="color:red" v-if="info.purchaseSite!=='部队'">*</span>
          <span style="color:red">*</span>军队级别：
          <Select
            v-model="info.level"
            style="width:250px;display:inline-block;"
            :disabled="!editSta"
          >
            <Option
              v-for="item in levelArr"
              :value="item.itemName"
              :key="item.key"
            >{{ item.itemName }}</Option>
          </Select>
        </span>
      </div>
      <div class="info-item">
        <span>
          <span style="color:red" v-if="info.purchaseSite!=='部队'">*</span>
          <span style="color:red">*</span>大单位：
          <Select
            v-model="info.kind1"
            style="width:184px;display:inline-block;"
            :disabled="!editSta"
          >
            <Option
              v-for="item in armyTypeArr"
              :value="item.itemName"
              :key="item.key"
            >{{ item.itemName }}</Option>
          </Select>
        </span>
      </div>
      <div class="info-item">
        <RadioGroup v-model="info.kind2" style="margin-right:30px">
          <Radio label="部队学校" :disabled="!editSta"></Radio>
          <Radio label="部队医院" :disabled="!editSta"></Radio>
          <Radio label="部队" :disabled="!editSta"></Radio>
        </RadioGroup>
      </div>
    </div>
    
    <div style="display:flex;margin-bottom:10px;align-items:center">
      <span style="color:red">*</span>联系地址：
      <Cascader :data="addressArr" v-model="address" :disabled="!editSta" style="width:252px" placeholder="请选择省/市/区"></Cascader>
      <Input
        class="oInp"
        v-model="info.contactAddress"
        placeholder="联系地址"
        style="width:350px;margin-left:10px"
        :readonly="!editSta"
      />
    </div>
    <div class="info-item">
      <span>备注：
        <Input v-model="info.comment"  placeholder="备注信息" style="width:617px"/>
      </span>
    </div>
    <!-- 联系人table -->
    <div style="margin:10px 0" v-show="editSta">
      <Button type="primary" @click="addVisible=true;title='新增联系人信息'" size="small">
        新增联系人与方式
      </Button>
    </div>
    <Table :height="info.contactPersonOrWay.length>3?'200':''" :columns="columns" :data="info.contactPersonOrWay"></Table>
    <div style="margin:10px;text-align: center" v-show="editSta">
      <Button @click="$emit('ok', false)">取消</Button>
      <Button type="primary" style="margin-left:10px" @click="submitP">保存</Button>
    </div>
    <!-- 跟进记录 -->
    <div v-show="!editSta">
      <h3 style="margin:20px 0 10px;display:flex;justify-content:space-between">
        <span>跟进记录</span>
        <span>
          <Button type="primary" @click="addVisitListVisible=true" size="small">
            新增拜访记录
          </Button>
          <Button type="error" @click="abandonFollow" size="small" style="margin-left:5px" v-show="user.name===info.accountAssistant">
            放弃跟进
          </Button>
        </span>
      </h3>
      <Table :height="followRecord.length>3?'200':''" :columns="recordColumns" :data="followRecord"></Table>
      <div style="margin:10px 0;text-align:center">
        <Button type="ghost" @click="getFollowRecord" v-show="followRecord.length>3">
          加载更多...
        </Button>
      </div>
    </div>
    <!-- 项目信息 -->
    <div v-show="!editSta">
      <h3 style="margin:20px 0 10px">项目信息</h3>
      <Table :height="projectData.length>3?'200':''" :columns="projectColumns" :data="projectData"></Table>
      <div style="margin:10px 0;text-align:center">
        <Button type="ghost" @click="getProjectData" v-show="projectData.length>3">
          加载更多...
        </Button>
      </div>
    </div>
    <!-- 联系人弹窗 -->
    <Modal v-model="addVisible" :title="title" width="680" :transfer="false" :mask-closable="false">
      <Form ref="contactForm" :model="contactForm" :rules="ruleValidate" :label-width="80">
        <Row>
          <Col span="12">
            <FormItem label="姓名" prop="联系人">
              <Input v-model="contactForm['联系人']" placeholder="请输入姓名"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="性别" prop="性别">
              <RadioGroup v-model="contactForm['性别']">
                <Radio label="男">男</Radio>
                <Radio label="女">女</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="6">
            <FormItem label="职位" prop="职位">
              <Input v-model="contactForm['职位']" placeholder="请输入职位"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="部门" prop="部门">
              <Input v-model="contactForm['部门']" placeholder="请输入部门"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="座机" prop="座机号码">
              <Input v-model="contactForm['座机号码']" placeholder="请输入固定电话"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="手机" prop="联系方式">
              <Input v-model="contactForm['联系方式']" placeholder="请输入手机号码"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="邮箱" prop="邮箱">
              <Input v-model="contactForm['邮箱']" placeholder="请输入个人邮箱"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="ghost" @click="handleReset('contactForm')">取消</Button>
        <Button type="primary" @click="handleSubmit('contactForm')" style="margin-left: 8px">确定</Button>
      </div>
    </Modal>
    <!-- 新增拜访 -->
    <Modal v-model="addVisitListVisible" width="950" title="添加客户拜访记录" :transfer="false">
			<visitListCard :curVisitListData="curVisitListData" :addStatus="'true+' + new Date().getTime()" :editPermission="false" :info="info" @ok="addOK"></visitListCard>
			<div slot="footer"></div>
		</Modal>
  </div>
</template>
<script>
import qs from 'qs'
import requestUrls from '@/lib/eRequestUrls'
import ajax from '@/lib/ajax'
import ChineseDistricts from '@/lib/area'
import visitListCard from '@/components/visitListCard2'
import userAjax from '@/lib/userAjax'

export default {
  name: 'purchaserCard',
  props: ["curPurchaserData", "editSta", "id", "time"],
  components: {
    visitListCard
  },
  data() {
    return {
      info: {
        "purchase": "",  // 单位名称
        "purchaseSite": "",   // 单位属性
        "contactPersonOrWay": [],
        "filiale": "",   // 归属团队
        "contactAddress": "",  // 联系地址
        "clientEmail": "",
        "sysIndustry": "",  // 所属行业
        "province": "",  // 省
        "city": "",  // 市
        "area": "",  // 区
        "accountAssistant": "",  // 客户人员
        "fundingSource": "",  // 资金来源
        "kind1": '', // 军种
        "kind2": '', 
        "level": '',
        "attachedUnit": '',
        "comment":''//  备注
      },
      showSus: false, //新增采购人成功时  提示 操作成功
      companyArea: [],//保存分公司 
      amArr: [],
      purchaseSiteArr: [],
      systemArr: [],
      addressArr: [],
      address: [],
      sourceArr: [],
      cgrList: [],
      addVisible: false,
      contactForm: {
        '联系人': '',
        '联系方式': '',
        '座机号码': '',
        '性别': '',
        '职位': '',
        '部门': '',
        '邮箱': '',
        '名片': ''
      },
      ruleValidate: {
        '联系人': [
            { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        '联系方式': [
            { required: true, message: '手机号码不能为空', trigger: 'blur' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        '座机号码': [
            { required: true, message: '座机号码不能为空', trigger: 'blur' }
        ],
        '性别': [
            { required: true, message: '请选择性别', trigger: 'change' }
        ]
      },
      title: '新增联系人信息',
      currentIndex: 0,
      columns: [
        {
          title: '姓名',
          width: 84,
          key: '联系人'
        },
        {
          title: '性别',
          width: 68,
          key: '性别'
        },
        {
          title: '职位',
          key: '职位'
        },
        {
          title: '部门',
          key: '部门'
        },
        {
          title: '邮箱',
          width: 120,
          key: '邮箱'
        },
        {
          title: '手机',
          width: 110,
          key: '联系方式'
        },
        {
          title: '座机',
          width: 120,
          key: '座机号码'
        },
        {
          title: '操作',
          align: 'center',
          width: 140,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: !this.editSta
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.addVisible = true
                    this.contactForm = Object.assign({}, params.row)
                    this.currentIndex = params.index
                    this.title = '修改联系人信息'
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: !this.editSta
                },
                on: {
                  click: () => {
                    this.info.contactPersonOrWay.splice(params.index, 1)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      recordColumns: [
        {
          title: '客户人员',
          key: 'am'
        },
        {
          title: '归属团队',
          key: 'filiale'
        },
        {
          title: '跟进途径',
          key: 'followApproach'
        },
        {
          title: '拜访结果',
          key: 'visitResult'
        },
        {
          title: '拜访日期',
          key: 'visitDate',
          render: (h, params) => {
            return h('div', params.row.visitDate.slice(0, 10))
          }
        },
        {
          title: '拜访时间',
          key: 'visitDateRange',
          render: (h, params) => {
            return h('div', params.row.visitDateRange)
          }
        }
      ],
      followRecord: [],
      projectColumns: [
        {
          title: '项目名称',
          key: 'projectName'
        },
        {
          title: '采购预算(元)',
          width: 110,
          key: 'purchaseBudget'
        },
        {
          title: '采购日期',
          align: 'center',
          width: 150,
          key: 'newProjectTime',
          render: (h, params) => {
            return h('div', params.row.newProjectTime.replace('T', ' '))
          }
        },
        {
          title: '代理机构',
          key: 'companyName'
        },
        {
          title: '操作',
          align: 'center',
          width: 90,
          render:(h, params) => {
            return h('a', {
              domProps: {
                target: 'blank',
                href: params.row.articleId ? `http://www.chinapsp.cn/notice_content.html?itemid=${params.row.articleId}` : 'javascript:void(0)'
              },
              style: {
                color: !params.row.articleId && '#ccc'
              }
            }, '查看公告')
          }
        }
      ],
      projectData: [],
      addVisitListVisible: false,
      curVisitListData: {
				// "客户名称": "",
				// "客户经理": this.$store.state.session.user.name,
				// "分公司": "",
				// "跟进途径": "",
				// "地址": "",
				// "拜访结果": "",
				// "拜访时间": "",
				// "是否为新客户": "",
				// "名片图片地址": "",
				// "名片": ""
      },
      armyTypeArr: []
    }
  },
  // 得到分公司列表
  async created() {
    let rep = await ajax.get(requestUrls.CLDistrict.GetListWithoutRole)
    this.companyArea = []
    if (rep.data.success) {
      this.companyArea = rep.data.result.items
    }
    // 获取单位属性
    let rep1 = await ajax.get('/api/services/app/AbpDataDict/GetListByType', {
      params: {
        type: '单位属性'  
      }
    })
    this.purchaseSiteArr = rep1.data.result.items
    // 获取行业系统
    let rep2 = await ajax.get('/api/services/app/AbpDataDict/GetListByType', {
      params: {
        type: 'IndustrySystem'  
      }
    })
    this.systemArr = rep2.data.result.items
    // 获取资金来源
    let rep3 = await ajax.get('/api/services/app/AbpDataDict/GetListByType', {
      params: {
        type: '资金来源'  
      }
    })
    this.sourceArr = rep3.data.result.items
    // 获取军种
    let rep4 = await ajax.get('/api/services/app/AbpDataDict/GetListByType', {
      params: {
        type: '军种'  
      }
    })
    this.armyTypeArr = rep4.data.result.items
    // 获取军队级别
    let rep5 = await ajax.get('/api/services/app/AbpDataDict/GetListByType', {
      params: {
        type: '军队级别'  
      }
    })
    this.levelArr = rep5.data.result.items
    // 获取采购人名称列表
    let rep6 = await ajax.get('/api/services/app/AbpDataDict/GetListByType', {
      params: {
        type: '采购人名称'  
      }
    })
    this.cgrList = rep6.data.result.items
    // 省市区
    this.addressArr = ChineseDistricts['86'].map(item => {
      return {  // 省
        id: item.code,
        value: item.address,
        label: item.address,
        children: Object.values(ChineseDistricts[item.code]).map((city, index) => {
          let code = Object.keys(ChineseDistricts[item.code])[index]
          return {  // 市
            id: code,
            value: city,
            label: city,
            children: !ChineseDistricts[code] ? [] : Object.values(ChineseDistricts[code]).map((region, index) => {
              return {  // 区
                value: region,
                label: region,
              }
            })
          }
        })
      }
    })
    // 获取客户人员
    userAjax.get(requestUrls.ClPurchase.GetAmClientQuota).then(res => {
      // 获取客户数量
      ajax.post(requestUrls.ClPurchase.PostAMCount, {
        data: res.data.result.items
      }).then(am => {
        this.amArr = am.data.result.items
        if (!this.permission) {
          this.amArr = this.amArr.filter(item => item.am === this.user.name)
        }
      })
    })
  },
  watch: {
    time() {
      this.reValue(); //重置 info 的值 
    },
    address(val) {
      [this.info.province, this.info.city, this.info.area] = val
    }
  },
  computed: {
    user() {
      return this.$store.state.session.user
    },
    permission () {
      let permission = this.$store.getters["session/hasRoles"]("分公司负责人") || this.$store.getters["session/hasRoles"]("档案管理员")
      return permission
    }
  },
  methods: {
    // 重置 info 的值
    reValue() {
      if (this.id == 0) {
        this.info = {
          "purchase": "",
          "purchaseSite": "",
          "contactPersonOrWay": [],
          "filiale": "",
          "contactAddress": "",
          "clientEmail": ""
        }
      } else {
        this.followRecord = []
        this.projectData = []
        this.info = JSON.parse(JSON.stringify(this.curPurchaserData))
        this.address = [this.info.province, this.info.city, this.info.area]
        
        this.getFollowRecord()
        this.getProjectData()
      }
    },
    // 获取跟进记录
    getFollowRecord () {
      ajax.get(requestUrls.CLCustomerVisit.getPurchaserVisitList, {
        params: {
          filter: `purchaseId == ${this.info.id}`,
          maxResultCount: 3,
          skipCount: this.followRecord.length,
          sorting: 'visitDate desc'
        }
      }).then(res => {
        this.followRecord = this.followRecord.concat(res.data.result.items)
        if (this.followRecord.length > 0 && res.data.result.items.length == 0) this.$Message.info('无更多跟进记录')
      })
    },
    // 获取项目信息
    getProjectData () {
      ajax.get('/api/services/app/ClProjectDb/GetPaged', {
        params: {
          filter: `purchaserName == "${this.info.purchase}"`,
          maxResultCount: 3,
          skipCount: this.projectData.length,
          sorting: 'newProjectTime desc'
        }
      }).then(res => {
        res.data.result.items.forEach(item => {
          // 根据项目编号获取公告信息
          ajax.get('/api/services/app/AbpArticles/GetPaged', {
            params: {
              filter: `a.projectNo == "${item.projectFull}"`
            }
          }).then(rep => {
            let articleId = rep.data.result.items.length > 0 ? rep.data.result.items[0].id : ''
            this.$set(item, 'articleId', articleId)
          })
        })
        this.projectData = this.projectData.concat(res.data.result.items)
        if (this.projectData.length > 0 && res.data.result.items.length == 0) this.$Message.info('无更多项目记录')
      })
    },
    // 添加联系人与方式
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 邮箱格式是否正确
          let reg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g
          if (!this.contactForm['邮箱']||reg.test(this.contactForm['邮箱'])) {
            this.addVisible = false
            if (this.title === '修改联系人信息') {
              this.$set(this.info.contactPersonOrWay, this.currentIndex, this.contactForm)
            } else {
              this.info.contactPersonOrWay.push(this.contactForm)
            }
          } else {
            this.$Message.error('请输入正确的邮箱格式!')
          }
        } else {
          this.$Message.error('请完善信息填写!');
        }
      })
    },
    handleReset (name) {
      this.addVisible = false
      // this.$refs[name].resetFields();
    },
    // 删除当前联系人与方式
    minusPT(index) {
      this.info.contactPersonOrWay.splice(index, 1);
    },
    // 新增采购人信息
    async submitP() {
      if (!this.info.purchase || !this.info.purchaseSite || !this.info.filiale || !this.info.contactAddress || !this.info.accountAssistant) {
        this.$Modal.info({
          title: '提示',
          content: '存在必填信息未填!(*为必填信息)'
        });
        return
      }
      // 是否部队
      if (this.info.purchaseSite === '部队' && (!this.info.kind1 || !this.info.kind2|| !this.info.level)) {
        this.$Modal.info({
          title: '提示',
          content: '存在必填信息未填!(*为必填信息)'
        });
        return
      }
      // 是否军工企业
      if (this.info.purchaseSite === '军工企业' && !this.info.attachedUnit) {
        this.$Modal.info({
          title: '提示',
          content: '存在必填信息未填!(*为必填信息)'
        });
        return
      }
      // // 检查当前客户人员是否超出客户限额
      // let currentAm = this.amArr.filter(item => item.am === this.info.accountAssistant)
      // if ((currentAm.count + 1) > currentAm.clientQuota) {
      //   this.$Message.error('当前客户人员限额已满，请选择其他')
      // }
      // 0  表示添加
      if (this.id == 0) {
        ajax.get(requestUrls.ClPurchase.GetPaged,{
          params: {
            filter: `purchase == "${this.info.purchase}"`,
            maxResultCount: 10,
            // skipCount: (page - 1) * 10,
          }
        }).then(req => {
          if (req.data.result.items.length != 0) {
            // 当采购人已经存在时
            this.$Modal.info({
              title: '提示',
              content: '添加的采购人已存在,不可重复添加,可对采购人信息进行修改操作!'
            });
          } else {
            // 二次确定是否确定添加采购人信息
            this.$Modal.confirm({
              // title: '二次确定',
              content: '<p>是否确定新增采购人信息</p>',
              onOk: () => {
                this.info.contactPersonOrWay = JSON.stringify(this.info.contactPersonOrWay)
                ajax.post('https://www.choicelink.cn:8444/cailian/api/dotnettoken/clPurchase/create', {
                  ...this.info
                }).then(res => {
                  this.$emit('ok', false) //关闭父组件所在 Modal
                  this.$Message.success('操作成功');
                })
              },
              onCancel: () => {
                this.$Message.info('取消成功');
              }
            });
          }
        })
      } else if (this.id == 2) { // 2  表示修改
        this.$Modal.confirm({
          // title: '二次确定',
          content: '<p>是否确定修改采购人信息</p>',
          onOk: () => {
            this.info.contactPersonOrWay = JSON.stringify(this.info.contactPersonOrWay)
            ajax.put('https://www.choicelink.cn:8444/cailian/api/dotnettoken/clPurchase/update', {
              ...this.info
            }).then(res => {
              this.$emit('ok', false) //关闭父组件所在 Modal
              this.$Message.success('操作成功');
            })
          },
          onCancel: () => {
            this.$Message.info('取消成功');
          }
        });
      }
    },
    // 放弃跟进
    abandonFollow () {
      this.$Modal.confirm({
        title: '放弃跟进',
        content: '<p>确定放弃跟进当前采购人吗？</p>',
        onOk: () => {
          let clPurchase = Object.assign(this.info,{
            accountAssistant: '',
            contactPersonOrWay: JSON.stringify(this.info.contactPersonOrWay)
          })
          ajax.post(requestUrls.ClPurchase.CreateOrUpdate, {
            clPurchase: clPurchase
          }).then(res => {
            this.$emit('ok', false) //关闭父组件所在 Modal
            this.$Message.success('操作成功');
          })
        },
        onCancel: () => {}
      })
    },
    // 添加成功后关闭Modal
		addOK: function (value) {
			this.addVisitListVisible = value;
    },
    siteChange (e) {
      if (e === '部队') this.info.sysIndustry = '部队系统'
      if (e === '军工企业') this.info.sysIndustry = '军工系统'
    }
  }
}
</script>

<style lang="less" scoped>
.info-item {
  min-width: 150px;
  margin: 0 0 10px 20px;
  display: inline-block;
  &:nth-child(3n - 2) {
    margin-left: 0;
  }
}
.info-item-span {
  display: inline-block;
  vertical-align: top;
  margin-top: 5px;
}
.oInp {
  color: red;
  width: 150px;
}
.bInp {
  margin-right: 30px;
}
.icon {
  vertical-align: middle;
}
// 包裹联系人与反思的Box
.ptBox {
  display: inline-block;
}
.ptBox div {
  margin-bottom: 5px;
}
li {
  list-style-type: none;
}
</style>